import React, { useState, useEffect, useContext } from 'react';
import { PieChart, Pie, ResponsiveContainer } from 'recharts';
import { API_BASE_URL } from '../../constants/apiConfig';
import LoginContext from '../LoginContext';

const UserTestStats = () => {
  const [stats, setStats] = useState<any>(null);
  const { userId }: any = useContext(LoginContext);

  useEffect(() => {
    fetch(`${API_BASE_URL}/admin/userTestStats?user_id=${userId}`, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data: any) => {
        setStats(data.stats[0]);
      })
      .catch((error) => {
        console.error("Error fetching user test stats:", error);
      });
  }, [userId]);

  if (!stats) {
    return <div className="p-6 text-center">Loading stats...</div>;
  }

  const scorePercent = parseFloat(stats.completed_score_percentage);
  
  // Data for the "Gauge" effect
  const chartData = [
    { value: scorePercent, fill: "#570df8" }, // Finished part
    { value: 100 - scorePercent, fill: "#f2f2f2" }, // Empty part
  ];

  return (
    <div className="p-6 bg-base-200 rounded-xl space-y-6">
      {/* DaisyUI Stats Card */}
      <div className="stats shadow w-full stats-vertical lg:stats-horizontal bg-base-100">
        <div className="stat">
          <div className="stat-title text-xs uppercase font-bold">Assigned</div>
          <div className="stat-value text-primary text-2xl">{stats.total_test_assigned}</div>
        </div>
        <div className="stat">
          <div className="stat-title text-xs uppercase font-bold">Completed</div>
          <div className="stat-value text-success text-2xl">{stats.total_completed}</div>
        </div>
        <div className="stat">
          <div className="stat-title text-xs uppercase font-bold">Pending</div>
          <div className="stat-value text-error text-2xl">{stats.total_pending}</div>
        </div>
        <div className="stat">
          <div className="stat-title text-xs uppercase font-bold">On-Time</div>
          <div className="stat-value text-secondary text-2xl">{stats.completed_on_time}</div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Score Gauge */}
        <div className="card bg-base-100 shadow-xl p-6 items-center">
          <h3 className="font-bold text-gray-500 mb-2">Score Percentage</h3>
          <div className="relative w-full h-48">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={chartData}
                  cx="50%"
                  cy="50%"
                  innerRadius="70%"
                  outerRadius="90%"
                  startAngle={180}
                  endAngle={0}
                  paddingAngle={0}
                  dataKey="value"
                />
               
              </PieChart>
            </ResponsiveContainer>
            {/* Center Label */}
            <div className="absolute inset-0 flex flex-col items-center justify-center mt-10">
              <span className="text-3xl font-black">{scorePercent.toFixed(1)}%</span>
              <span className="text-xs text-gray-400">Total Accuracy</span>
            </div>
          </div>
        </div>

        {/* Marks Card */}
        <div className="card bg-primary text-primary-content shadow-xl p-6 justify-center">
          <div className="stat p-0">
            <div className="stat-title text-primary-content opacity-70">Total Marks Scored</div>
            <div className="stat-value text-5xl">{stats.total_marks_scored}</div>
            <div className="stat-desc text-primary-content mt-2">
              Out of {parseInt(stats.total_completed) * 10} possible points
            </div>
          </div>
          <div className="card-actions justify-end mt-4">
            <button className="btn btn-sm btn-ghost bg-white/20">View Details</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserTestStats;
